import CalendarSurfaceItemBase from './itemTemplates/CalendarSurfaceItem.base';
import React from 'react';
import { CalendarSurfaceItemProps } from './itemTemplates/CalendarSurfaceItem.types';
import { getStyles } from './itemTemplates/CalendarSurfaceItem.styles';

let surfaceItemStyles = require('./CalendarSurfaceItem.scss');

export default function CalendarSurfaceBlankItem(props: CalendarSurfaceItemProps) {
    const renderContent = () => {
        const { children } = props;
        return children ? <> {children} </> : <div className={surfaceItemStyles.itemContent} />;
    };
    return <CalendarSurfaceItemBase {...props} onRender={renderContent} styles={getStyles} />;
}
